import { Download, Database, ShieldAlert } from "lucide-react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { toast } from "sonner";

export default function BackupClinica() {
  const [scope, setScope] = useState("clinica");
  const [loading, setLoading] = useState(false);

  const exportarBackup = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/backup.php?scope=${encodeURIComponent(scope)}`, {
        credentials: "include",
      });
      const payload = await response.json();
      if (!response.ok || payload.error) throw new Error(payload.error || "Erro ao gerar backup");
      const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
      link.href = url;
      link.download = `odonto-backup-${scope}-${stamp}.json`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      toast.success("Backup exportado");
    } catch (error: any) {
      toast.error(error?.message || "Erro ao exportar backup");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-semibold">Backup e Exportação</h1>
          <p className="text-sm text-muted-foreground">Exporte os dados em JSON para conferência, auditoria ou segurança operacional.</p>
        </div>

        <div className="grid gap-4 lg:grid-cols-[1fr_360px]">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Database className="h-5 w-5" />
                Exportar dados
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label>Escopo</Label>
                <Select value={scope} onValueChange={setScope}>
                  <SelectTrigger className="max-w-sm"><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="clinica">Clínica/unidade ativa</SelectItem>
                    <SelectItem value="cliente">Cliente inteiro</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button onClick={exportarBackup} disabled={loading}>
                <Download className="mr-2 h-4 w-4" />
                {loading ? "Gerando..." : "Exportar backup"}
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-base">
                <ShieldAlert className="h-5 w-5" />
                Regra de segurança
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              A restauração direta fica reservada ao SuperAdmin para evitar sobrescrever dados por engano. O arquivo exportado serve como cópia de segurança e base de auditoria.
            </CardContent>
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
}
